module.exports = __webpack_public_path__ + "static/Access_Unparalleled_Talent-8cd024e6266823124a0b2783a9b435b7.png";